const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export default {
  methods: {
    currencyFormatter(value) {
      return formatter.format(value);
    },
    usdFormatter(r, c, v) {
      return this.currencyFormatter(v);
    },
    myDebounce(fn, delay = 200) {
      let timer = null;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(this);
        }, delay);
      };
    },
    myThrottle(fn, delay = 200) {
      var lastTime = 0;
      return function () {
        var nowTime = Date.now();
        if (nowTime - lastTime > delay) {
          fn.call(this);
          lastTime = nowTime;
        }
      };
    },
  }
};